/**
 * Read a parameter out of the URL fragment.
 *
 * Taken raw from `window.location.hash` rather than the router's location: the
 * router hands back a hash it has already run `decodeURI` over, and a token
 * decoded twice is a token that can come back wrong.
 */
export function readFragmentParam(name: string): string {
  const hash = window.location.hash;
  if (!hash) return '';
  return new URLSearchParams(hash.slice(1)).get(name) ?? '';
}

/**
 * Drop the fragment from the address bar, leaving the history stack alone.
 *
 * Rewriting the current entry is what keeps the token out of Back — pushing a
 * clean URL would leave the credential-bearing one behind it.
 */
export function clearFragment(): void {
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}`
  );
}
